import { render, staticRenderFns } from "./PostaCreate.vue?vue&type=template&id=5eb74ede&scoped=true&"
import script from "./PostaCreate.vue?vue&type=script&lang=js&"
export * from "./PostaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb74ede",
  null
  
)

export default component.exports